/**
 * Parent-facing minimum-enrollment contingency.
 *
 * Shown ONLY where money is being collected (paid checkout/registration and the
 * paid registration confirmation email). Never on interest-only forms, and
 * never phrased as an automatic cancellation — a class "may be postponed".
 */
export const MIN_ENROLLMENT_POLICY_TEXT =
  "Classes require a minimum enrollment of 5 students. If the minimum is not met, the class may be postponed. Families may choose either a refund or to transfer the amount paid as credit toward another class or a future class.";
